
  import { defineComponent } from 'vue';
  import { mapGetters } from 'vuex';

  import ExportButtons from '@/common/components/redesigned/ExportButtons.vue';
  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  // import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import { downloadPDF } from '@/common/utils/fileExport';
  import { getCurrentYear } from '@/common/utils/year';

  import apiDashboards from '../api/dashboardsVES';
  import DateActualDataSubtitle from '../components/common/DateActualDataSubtitle.vue';
  import DashboardsCards from '../components/dashboards/DashboardsCards.vue';
  import DashboardsChart from '../components/dashboards/DashboardsChart.vue';
  import DashboardsChartsBlock from '../components/dashboards/DashboardsChartsBlock.vue';
  import DashboardsMapBlock from '../components/dashboards/DashboardsMapBlock.vue';
  import DashboardsTables from '../components/dashboards/DashboardsTables.vue';
  import DashboardsYearFilterBlock from '../components/dashboards/DashboardsYearFilterBlock.vue';
  import { DEFAULT_DASHBOARDS_FILTER } from '../constants/dashboards';
  import { DASHBOARDS_VES_GETTERS_NAME } from '../store/dashboards/name';
  import {
    TDashboardMainFilter,
    TDashboardMainFilterWithOptionalYear,
    TEventsTableFilter,
    TTopPartnerRating,
  } from '../types/dashboards';
  import { moveDashboardsChartsToTopLevel } from '../utils/dashboardsCharts';

  export default defineComponent({
    name: 'DashboardsVES',
    components: {
      PageTitle,
      DashboardsYearFilterBlock,
      DashboardsCards,
      DashboardsMapBlock,
      DashboardsChartsBlock,
      DashboardsChart,
      ExportButtons,
      DateActualDataSubtitle,
      DashboardsTables,
    },
    mixins: [security],
    data(): { filter: TDashboardMainFilter; plannedEventsRegionRfIds: number[]; isExportProgress: boolean } {
      return {
        filter: { ...DEFAULT_DASHBOARDS_FILTER },
        plannedEventsRegionRfIds: [],
        isExportProgress: false,
      };
    },
    created() {
      if (this.$route.query.year) this.filter.year = String(this.$route.query.year);

      // ? Для администратора ВЭС не работает по ТЗ, поэтому пока закомментировал
      // this.checkPermissionAndRedirect(Constants.Permissions.AdminAccess);
    },
    computed: {
      ...mapGetters({
        topCountryPartners: DASHBOARDS_VES_GETTERS_NAME.getTopCountryPartners,
      }),
      getExportFilter() {
        return { ...this.filter, regionRfIds: this.plannedEventsRegionRfIds };
      },
      calendarParams(): { isSystemEvent: boolean } {
        return { isSystemEvent: false };
      },
      // Блок «Топ-5 стран» скрывается, если данных нет (ТЗ)
      isChartVisible(): boolean {
        return Array.isArray(this.topCountryPartners) && (this.topCountryPartners as TTopPartnerRating[]).length > 0;
      },
    },
    methods: {
      changeFilter(value: TDashboardMainFilterWithOptionalYear) {
        const newYear = value.year ?? String(getCurrentYear());
        this.filter.year = newYear;
        this.$router.replace({
          query: { ...this.$route.query, year: newYear },
        });
      },
      async downloadPDF() {
        this.isExportProgress = true;
        try {
          await downloadPDF({
            clonedElementClassName: 'dashboards-ves__export-pdf',
            pagebreakMode: 'table-friendly',
            clonedNodeFormatter: moveDashboardsChartsToTopLevel,
            fileName: 'Мониторинг_реализации_документов_по_ВЭС',
          });
        } finally {
          this.isExportProgress = false;
        }
      },
      changePlannedEventsFilter(filter: TEventsTableFilter) {
        this.plannedEventsRegionRfIds = filter.subjectRfIds ?? [];
      },
      async downloadPptx() {
        this.isExportProgress = true;
        try {
          await apiDashboards.exportPptx('export', this.getExportFilter);
        } finally {
          this.isExportProgress = false;
        }
      },
    },
  });
